// extracted by mini-css-extract-plugin
export default {"navPageNickNameConnected":"py_pz"};